/**
 * Navigation configuration for the application sidebar
 * Defines the structure, routes, labels, and icons for navigation items
 *
 * Uses hierarchical permission system - admins/superadmins automatically
 * inherit access to all feature sections
 */

import { PERMISSIONS } from '@features/auth/utils/permissionRules';

export const NAVIGATION_CONFIG = {
  main: [
    { path: '/', labelKey: 'sidebar.home', icon: 'lucide:message-square-plus' },
  ],
  sections: [
    {
      titleKey: 'sidebar.knowledge',
      permission: PERMISSIONS.MANAGE_KNOWLEDGE,
      items: [
        { path: '/knowledge-bases', labelKey: 'sidebar.knowledgeBases', icon: 'lucide:database' },
      ],
    },
    {
      titleKey: 'sidebar.emergencies',
      permission: PERMISSIONS.MANAGE_EMERGENCY,
      items: [
        { path: '/emergency-substitutions-list', labelKey: 'sidebar.substitutions', icon: 'lucide:user-check' },
      ],
    },
    {
      titleKey: 'sidebar.onboarding',
      permission: PERMISSIONS.MANAGE_ONBOARDING,
      items: [
        { path: '/onboarding/workflows', labelKey: 'sidebar.workflows', icon: 'lucide:workflow' },
        { path: '/onboarding/instances', labelKey: 'sidebar.onboardingProgress', icon: 'lucide:user-check' },
      ],
    },
    {
      titleKey: 'sidebar.engagementPulse',
      permission: PERMISSIONS.MANAGE_ENGAGEMENT,
      items: [
        { path: '/engagement-pulse', labelKey: 'sidebar.engagementDashboard', icon: 'lucide:activity' },
      ],
    },
    {
      titleKey: 'sidebar.administration',
      permission: PERMISSIONS.MANAGE_CONVERSATIONS,
      hideForSuperadmin: true,
      items: [
        { path: '/admin/conversations', labelKey: 'sidebar.conversations', icon: 'lucide:messages-square' },
        { path: '/admin/users', labelKey: 'sidebar.users', icon: 'lucide:users', permission: PERMISSIONS.ADMIN_ACCESS },
      ],
    },
    {
      titleKey: 'sidebar.superAdmin',
      permission: PERMISSIONS.CROSS_ACCOUNT_ACCESS,
      items: [
        { path: '/superadmin/conversations', labelKey: 'sidebar.conversations', icon: 'lucide:messages-square' },
        { path: '/superadmin/users', labelKey: 'sidebar.users', icon: 'lucide:users' },
      ],
    },
  ],
};

export const AVAILABLE_LANGUAGES = ['en', 'es', 'ca'];
